import React from 'react'
import {
    Navbar,
    Hero,
    HowItWorks,
    GetPaid,
    AreasWeCover,
    Team,
    Stories,
    ContactUs,
    Footer
} from "./../../components"

const Home = () => {
  return (
    <div>
        <Navbar />
        <Hero />
        <Stories />
        <HowItWorks />
        <GetPaid />
        <AreasWeCover />
        <Team />
        <ContactUs />
        <Footer />
    </div>
  )
}

export default Home